import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { CommonService } from 'src/app/common.service';

@Component({
  selector: 'app-checkout-success',
  templateUrl: './checkout-success.component.html',
  styleUrl: './checkout-success.component.css'
})
export class CheckoutSuccessComponent implements OnInit  {
  load: boolean = false;
  msg: string = '';
  session_id = '';
  plan = '';
  clientSecret: '';
  constructor(private route: ActivatedRoute, private router: Router, private dataservice: CommonService) {
    // this.session_id = this.route.snapshot.params.session_id;
    this.route.queryParams.subscribe(params => {
      this.session_id = params['session_id'];
      this.plan = params['plan']??'';
  });
    console.log(this.session_id,this.plan);
    if(this.session_id != ''  && this.session_id != '0'  && this.plan != 'One Time Starter Plan' && this.plan != 'Monthly Starter Plan' && this.plan != 'Yearly Starter Plan'){
      this.checkout();
    }else{
      this.msg = this.plan+" activated successfuly.";
      this.load = true;
    }
  }
  ngOnInit(): void {
    this.dataservice.getData('/api/user-details').pipe(
      map((res: Response) => (res)))
      .subscribe(
        (response) => {
          console.log(response);
          localStorage.setItem('plan',response['user']['active_subscription']['plan']);
        },
        (error) => {
          if (error.status === 401) {
            this.load = false;
            this.dataservice.tokenExpireLogout();
          } else {
            console.log(error);
          }
        });
  }
  checkout() {
    const data = {
      session_id: this.session_id
    };
    this.dataservice.sendPostRequest('/api/checkout-success', data).pipe(
      map((res: Response) => (JSON.stringify(res))))
      .subscribe(
        (response) => {
          this.load = true;
          const result = JSON.parse(response);
          console.log(result);
          this.msg = result.success;
          let thisvar = this;
          setTimeout(function(){
            thisvar.router.navigate(['panel/campaigns']);
          },5000);
        },
        (error) => {
          this.load = true;
          if (error.status === 401) {
            this.msg = error.error.error_message;
            // this.openSnackBar(error.error.error_message,'Dismiss');
          } else {
            this.msg = error.error.error_message;
            // this.openSnackBar(error.error.error_message,'Dismiss');
          }
          console.log(error);
        });
  }
}
